import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import { injectIntl } from 'react-intl';
import { displayPromoHeader, i18nIntl, isNotEmpty } from '../../lib/ep';
import { useCSS } from '../../lib/hooks';

import ActionButton, { MainButton, SquaredButton } from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import ButtonCollection from '../builder/ButtonCollection';
import TimeCounterSimple from '../builder/TimeCounterSimple';

import CustomMenu from './CustomMenu';
import FloatingLayerPublic from './FloatingLayerPublic';
import MyNetsButtons from './MyNetsButtons';
import MyParticipationMenuHeader from './MyParticipationMenuHeader';

import PendingParticipations from './loyalty/PendingParticipations';
import TokensWallet from './loyalty/TokensWallet';

import LeveledHTMLText from './helpers/LeveledHTMLText';
import { HeaderPWABanner } from './PWAInstallBanner';

const displayTokens = (props) => {
	const is_builder = props?.is_builder ?? false;
	const has_tokens = (props?.loyalty_tokens != undefined) ? true : false;
	const is_logged = (isNotEmpty(window, 'login_info') || isNotEmpty(props, 'login_id')) ? true : false;
	return (!is_builder && is_logged && has_tokens) ? true : false;
};

const displayPendingParticipations = (props) => {
	const is_builder = props?.is_builder ?? false;
	const is_logged = (isNotEmpty(window, 'login_info') || isNotEmpty(props, 'login_id')) ? true : false;
	return (!is_builder && is_logged) ? true : false;
};

const LogoImage = (props) => {
	const return_null_if_empty = props?.return_null_if_empty ?? false;
	const _logo_image = (isNotEmpty(props, 'logo_image')) ? props.logo_image : false;

	if(_logo_image === false && return_null_if_empty) {
		return null;
	}

	if(_logo_image === false && !return_null_if_empty) {
		return (
			<div class="logo is_empty" />
		)
	}

	const logo_image = props?.full_logo_image ?? _logo_image;

	const logo_url = (isNotEmpty(props, 'logo_url')) ? props.logo_url : false;
	if(logo_url !== false) {
		return (
			<span class="logo">
				<ActionLink
					autotranslate={false}
					_href={logo_url}
					_target='_blank'
				>
					<img src={logo_image} alt="" />
				</ActionLink>
			</span>
		)
	}

	return (
		<span class="logo">
			<img src={logo_image} alt="" />
		</span>
	)
};

const HeaderWrapper = ({ is_test, is_invitation, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const is_builder = props?.is_builder ?? false;
	const is_copyable = (!is_builder) ? (props?.is_copyable ?? false) : false;

	let enable_test = (is_test || is_invitation) ? true : false;
	if(is_copyable) enable_test = false;

	const [ display_test, setDisplayText ] = useState(enable_test);
	const [ display_copy_layer, setDisplayCopyLayer ] = useState(false);

	const type = props?.type ?? 'classic';

	const promotion_id = props?.promotion_id ?? false;
	document.querySelector('#ep-global-contents')?.classList.add('is_test');

	const test_classes = ['gui_test_advise', 'not_awesome', `is_${type}`];
	if(!display_test) test_classes.push('is_hidden');

	useEffect(() => {
		if(!is_copyable) return;

		setTimeout(() => {
			setDisplayText(true);
		}, 3000);
	}, []);

	if(is_copyable) {
		test_classes.push('is_copyable_msg');

		return (
			<>
				<div
					class={test_classes.join(" ")}
					onClick={() => setDisplayCopyLayer(true)}
					style={{ '--test-width':'20em' }}
				>
					<p>{i18n("I want this template!")}</p>

					<ButtonCollection>
						<SquaredButton
							icon='ep-check-list-item'
							color='orange'
							onClick={() => setDisplayCopyLayer(true)}
							aria-label="Open layer"
						/>

						<SquaredButton
							icon='ep-delete-circle'
							color='middarkgray'
							onClick={(e) => {
								e.stopPropagation();
								setDisplayText(false);
							}}
							aria-label="Delete"
						/>
					</ButtonCollection>
				</div>

				{props.children}

				{(display_copy_layer) && (
					<FloatingLayerPublic
						backButton={() => setDisplayCopyLayer(false)}
						_class={{ other:'website_emulated not_awesome' }}
					>
						<LeveledHTMLText>
							<h1>{i18n("Do you like this template?")}</h1>

							<p>{i18n("Identify now with your Easypromos account and configure your next campaign from this template.")}</p>
						</LeveledHTMLText>

						<div class="cta_with_img">
							<div class="cta">
								<ButtonCollection _class={{ other:'flex_button' }}>
									<MainButton
										_fullclass="knk-view open_outside"
										_href={`${window.panel_url}copy_demo/${promotion_id}`}
									>Use template</MainButton>
								</ButtonCollection>

								<p>{i18n("If you still do not have an Easypromos account you will be able to create a new one for free through a very simple steps.")}</p>
							</div>

							<div class="img">
								<img
									src={`/img/easy-templates.png`}
									width="100%"
									alt=""
								/>
							</div>
						</div>
					</FloatingLayerPublic>
				)}
			</>
		)
	}

	if(enable_test) {
		test_classes.push('gui_only_desktop');

		return (
			<>
				<div class={test_classes.join(" ")}>
					{(is_test) && (
						<p>Test mode</p>
					)}
					
					{(!is_test && is_invitation && isNotEmpty(is_invitation, 'name')) && (
						<p>{is_invitation.name}</p>
					)}

					{(promotion_id !== false) && (
						<ButtonCollection>
							{(is_invitation) && (
								<div class="testing_invitation">
									<div id="timeLeftTestInvite">
										<TimeCounterSimple
											hide_days={true}
											seconds={is_invitation.second}
										/>
									</div>
								</div>
							)}

							{(!is_invitation) && (
								<SquaredButton
									icon='knk-desktop'
									disabled={true}
								/>
							)}

							{(!is_invitation) && (
								<SquaredButton
									icon='knk-samsung-galaxy-p'
									_href={`/promotions/preview/${promotion_id}`}
									_target='_blank'
									aria-label="Preview"
								/>
							)}

							<SquaredButton
								icon='ep-delete-circle'
								color='red'
								onClick={() => setDisplayText(false)}
								aria-label="Delete"
							/>
						</ButtonCollection>
					)}
				</div>

				{props.children}
			</>
		)
	}

	return (
		<>
			{props.children}
		</>
	)
};

const MainMenuEmpty = (props) => {
	const main_classes = ['promo_header', 'awesome', 'empty_header'];

	return (
		<header class={main_classes.join(" ")} />
	)
};

const MainMenuSimple = ({ promo, ...props }) => {
	const layout_props = promo?.layout_props ?? {};
	const is_builder = props?.is_builder ?? false;
	const hide_menu = props?.hide_menu ?? false;
	const manifest_enabled = props?.manifest_enabled ?? false;
	const actual_page = props?.actual_page ?? 'landing';

	const force_display = (is_builder && (props?.force_display ?? false)) ? true : false;

	const [ open, setOpen ] = useState(force_display);

	useEffect(() => {
		if(is_builder) {
			setOpen(props?.force_display ?? false);
		}
	}, [ props.force_display ]);
	
	const menus = props?.menus ?? [];
	if(menus.length < 1) return null;

	let main_classes = ['promo_header', 'openable_promo_header', 'awesome', 'simple_header'];
	if(open) main_classes.push('is_open');

	let header_classes = ['header_cont'];
	let menu_classes = ['menu_sections'];

	const display_my_participation = props?.display_my_participation ?? false;
	const display_my_networks = layout_props?.header?.display_my_networks ?? true;

	const hide_user_info_in_header = layout_props?.header?.hide_user_info_in_header ?? false;
	const hide_won_prizes_in_header = layout_props?.header?.hide_won_prizes_in_header ?? true;

	const menu_icon = layout_props?.header?.menu_icon ?? 'burguer';
	
	return (
		<header class={main_classes.join(" ")}>
			<div class={header_classes.join(" ")}>
				<LogoImage
					{...(layout_props?.header ?? {})}
				/>

				{(manifest_enabled) && (
					<HeaderPWABanner
						promotion={{ Promotion:promo }}
						actual_page={actual_page}
						in_header={true}
						is_builder={is_builder}
						intl={props.intl}
					/>
				)}

				{(displayPendingParticipations(props)) && (
					<PendingParticipations
						pending_tickets={props.pending_tickets}
						promotion_id={promo.id}
						intl={props.intl}
						locale={props.locale}
					/>
				)}

				{(displayTokens(props)) && (
					<TokensWallet
						tokens={props.loyalty_tokens.tokens}
						totals={props.loyalty_tokens.totals}
						type='simple'
						link_props={{
							_href:`/loyalty/my_rewards/${promo.id}`,
						}}
						intl={props.intl}
						locale={props.locale}
					/>
				)}

				{(display_my_participation && !hide_user_info_in_header) && (
					<MyParticipationMenuHeader
						login_data={props.login_data}
						login_id={props.login_id}
						promotion_id={promo.id}
						hide_won_prizes_in_header={hide_won_prizes_in_header}
						//display_prize_shop={display_prize_shop}
						in_sidebar={false}
					/>
				)}

				<div class="menu_actions">
					{(!hide_menu) && (
						<ActionButton
							_fullclass={(!open) ? `ep-${menu_icon}-menu` : 'ep-sided-menu-opened'}
							onClick={() => setOpen((!force_display) ? !open : true)}
						/>
					)}
				</div>
			</div>

			<nav class={menu_classes.join(" ")} aria-label='builder main menu'>
				{(!hide_menu) && (
					<CustomMenu
						menus={menus}
						pm={promo}
						share_info={props.share_info}
						is_builder={is_builder}
					/>
				)}

				{(display_my_participation) && (
					<MyParticipationMenuHeader
						login_data={props.login_data}
						login_id={props.login_id}
						promotion_id={promo.id}
						hide_won_prizes_in_header={hide_won_prizes_in_header}
						//display_prize_shop={display_prize_shop}
						in_sidebar={true}
					/>
				)}

				{(display_my_networks) && (
					<MyNetsButtons
						promotion={promo}
						networks={promo?.my_networks?.sections?.[0]?.nets ?? []}
						share_info={props.share_info}
						type="success"
						is_builder={is_builder}
					/>
				)}
			</nav>
		</header>
	)
};

const MainMenuTabs = ({ promo, ...props }) => {
	const layout_props = promo?.layout_props ?? {};
	const is_builder = props?.is_builder ?? false;
	const hide_menu = props?.hide_menu ?? false;
	const manifest_enabled = props?.manifest_enabled ?? false;
	const actual_page = props?.actual_page ?? 'landing';

	const menus = props?.menus ?? [];
	if(menus.length < 1) return null;

	const main_classes = ['promo_header', 'awesome', 'tabbed_header'];
	const menu_classes = ['menu_sections', 'tabbed_menu'];

	const display_my_participation = props?.display_my_participation ?? false;
	const display_my_networks = layout_props?.header?.display_my_networks ?? true;
	const hide_user_info_in_header = layout_props?.header?.hide_user_info_in_header ?? false;
	const hide_won_prizes_in_header = layout_props?.header?.hide_won_prizes_in_header ?? true;
	const display_share = ((promo.config?.share?.status ?? '1') == '1') ?? true;

	return (
		<header class={main_classes.join(" ")}>
			<div class="header_cont">
				<LogoImage
					{...(layout_props?.header ?? {})}
					return_null_if_empty={true}
				/>

				<nav class={menu_classes.join(" ")}>
					{(!hide_menu) && (
						<CustomMenu
							menus={menus}
							pm={promo}
							share_info={props.share_info}
							is_builder={is_builder}
							display_icons={false}
						/>
					)}
				</nav>

				{(manifest_enabled) && (
					<HeaderPWABanner
						promotion={{ Promotion:promo }}
						actual_page={actual_page}
						in_header={true}
						is_builder={is_builder}
						intl={props.intl}
					/>
				)}

				{(displayPendingParticipations(props)) && (
					<PendingParticipations
						promotion_id={promo.id}
						pending_tickets={props.pending_tickets}
						intl={props.intl}
						locale={props.locale}
					/>
				)}

				{(displayTokens(props)) && (
					<TokensWallet
						tokens={props.loyalty_tokens.tokens}
						totals={props.loyalty_tokens.totals}
						type='simple'
						link_props={{
							_href:`/loyalty/my_rewards/${promo.id}`,
						}}
						intl={props.intl}
						locale={props.locale}
					/>
				)}

				{(display_my_participation && !hide_user_info_in_header) && (
					<MyParticipationMenuHeader
						login_data={props.login_data}
						login_id={props.login_id}
						promotion_id={promo.id}
						hide_won_prizes_in_header={hide_won_prizes_in_header}
						//display_prize_shop={display_prize_shop}
						in_sidebar={false}
					/>
				)}

				{/*<PunchCardMenuHeader
					login_data={props.login_data}
					login_id={props.login_id}
					promotion_id={promo.id}
				/>*/}

				{(display_my_networks || display_share) && (
					<div class="menu_networks">
						<MyNetsButtons
							promotion={promo}
							networks={promo.my_networks.sections[0].nets}
							share_info={props.share_info}
							type="header"
							is_builder={is_builder}
							display_my_networks={display_my_networks}
						/>
					</div>
				)}
			</div>
		</header>
	)
};

const MainMenuClassic = ({ promo, ...props }) => {
	const layout_props = promo?.layout_props ?? {};
	const is_builder = props?.is_builder ?? false;
	const hide_menu = props?.hide_menu ?? false;
	const manifest_enabled = props?.manifest_enabled ?? false;
	const actual_page = props?.actual_page ?? 'landing';

	const force_display = (is_builder && (props?.force_display ?? false)) ? true : false;

	const [ open, setOpen ] = useState(force_display);

	useEffect(() => {
		if(is_builder) {
			setOpen(props?.force_display ?? false);
		}
	}, [ props.force_display ]);

	const menus = props?.menus ?? [];
	if(menus.length < 1) return null;

	let main_classes = ['promo_header', 'openable_promo_header', 'awesome', 'classic_header'];
	if(open) main_classes.push('is_open');

	let header_classes = ['header_cont'];
	let menu_classes = ['menu_sections', 'gui_sharing_menu'];

	const display_my_participation = props?.display_my_participation ?? false;
	const display_my_networks = layout_props?.header?.display_my_networks ?? true;
	const hide_user_info_in_header = layout_props?.header?.hide_user_info_in_header ?? false;
	const hide_won_prizes_in_header = layout_props?.header?.hide_won_prizes_in_header ?? true;
	const display_share = ((promo.config?.share?.status ?? '1') == '1') ?? true;

	const menu_icon = layout_props?.header?.menu_icon ?? 'burguer';

	return (
		<header class={main_classes.join(" ")}>
			<div class={header_classes.join(" ")}>
				{/*<LogoImage
					{...(layout_props?.header ?? {})}
					return_null_if_empty={true}
				/>*/}

				<div class="menu_actions">
					{(!hide_menu) && (
						<ActionButton
							_fullclass={(!open) ? `ep-${menu_icon}-menu` : 'ep-sided-menu-opened'}
							onClick={() => setOpen((!force_display) ? !open : true)}
						/>
					)}
				</div>

				{(manifest_enabled) && (
					<HeaderPWABanner
						promotion={{ Promotion:promo }}
						actual_page={actual_page}
						in_header={true}
						is_builder={is_builder}
						intl={props.intl}
					/>
				)}

				{(displayPendingParticipations(props)) && (
					<PendingParticipations
						promotion_id={promo.id}
						pending_tickets={props.pending_tickets}
						intl={props.intl}
						locale={props.locale}
					/>
				)}

				{(displayTokens(props)) && (
					<TokensWallet
						tokens={props.loyalty_tokens.tokens}
						totals={props.loyalty_tokens.totals}
						type='simple'
						link_props={{
							_href:`/loyalty/my_rewards/${promo.id}`,
						}}
						intl={props.intl}
						locale={props.locale}
					/>
				)}

				{(display_my_participation && !hide_user_info_in_header) && (
					<MyParticipationMenuHeader
						login_data={props.login_data}
						login_id={props.login_id}
						promotion_id={promo.id}
						hide_won_prizes_in_header={hide_won_prizes_in_header}
						//display_prize_shop={display_prize_shop}
						in_sidebar={false}
					/>
				)}
				
				{/*<PunchCardMenuHeader
					login_data={props.login_data}
					login_id={props.login_id}
					promotion_id={promo.id}
				/>*/}

				{(display_my_networks || display_share) && (
					<div class="menu_networks">
						<MyNetsButtons
							promotion={promo}
							networks={promo?.my_networks?.sections?.[0]?.nets ?? []}
							share_info={props.share_info}
							type="header"
							is_builder={is_builder}
							display_my_networks={display_my_networks}
						/>
					</div>
				)}
			</div>

			{(open) && (
				<aside
					class="close_sided_menu"
					onClick={() => setOpen((!force_display) ? false : true)}
				/>
			)}

			<nav class={menu_classes.join(" ")}>
				{(!hide_menu) && (
					<CustomMenu
						menus={menus}
						pm={promo}
						share_info={props.share_info}
						is_builder={is_builder}
					/>
				)}

				{(display_my_participation) && (
					<MyParticipationMenuHeader
						login_data={props.login_data}
						login_id={props.login_id}
						promotion_id={promo.id}
						hide_won_prizes_in_header={hide_won_prizes_in_header}
						//display_prize_shop={display_prize_shop}
						in_sidebar={true}
					/>
				)}
			</nav>
		</header>
	)
};

const MainMenuFlex = forwardRef(({ promo, ...props }, ref) => {
	useCSS('comp/promo_header.css');

	const is_builder = props?.is_builder ?? false;
	const is_test = (!is_builder) ? (promo?.test ?? false) : false;
	const force_display = props?.force_display ?? false;
	const force_type = props?.force_type ?? false;
	const is_invitation = props?.is_invitation ?? null;
	const hide_menu = props?.hide_menu ?? false;

	const [ fits_as_tabs, setFitsAsTabs ] = useState(true);
	const [ loyalty_tokens, setLoyaltyTokens ] = useState(props?.loyalty_tokens ?? {});

	useImperativeHandle(ref, () => ({
		setTokens(new_totals) {
			setLoyaltyTokens({
				...loyalty_tokens,
				totals:new_totals,
			});
		},
	}), []);

	const menus = props?.menus ?? [];

	const login_id = props?.login_id ?? false;
	const login_data = props?.login_data ?? false;
	const is_multistage = promo?.is_multistage ?? false;
	const display_my_participation = (is_multistage || (login_id !== false && login_data !== false)) ? true : false;

	const manifest_enabled = promo?.manifest_enabled ?? false;

	const layout_props = promo?.layout_props ?? {};
	const menu_layout = (force_type !== false) ? force_type : (layout_props?.header?.type ?? 'classic');

	const min_width_for_tabs = useRef(0);

	const wrapper_props = {
		is_test,
		is_invitation,
		is_builder,
		is_copyable:promo?.copyable ?? false,
		promotion_id:promo.id,
		type:menu_layout,
		intl:props.intl,
	};

	const checkIfTabsFit = () => {
		if(menu_layout != 'tab' || document.querySelector('.header_cont') == undefined) return;

		const viewport_w = document.querySelector('.header_cont').offsetWidth;
		setFitsAsTabs((viewport_w > (min_width_for_tabs.current + 20)) ? true : false);
	};

	useEffect(() => {
		if(menu_layout != 'tab') return;

		const tabbed_menu_w = document.querySelector('.navigation_menu');
		const networks_menu_w = document.querySelector('.menu_networks');

		min_width_for_tabs.current = 0;
		if(tabbed_menu_w != undefined) min_width_for_tabs.current += tabbed_menu_w.offsetWidth;
		if(networks_menu_w != undefined) min_width_for_tabs.current += networks_menu_w.offsetWidth;

		checkIfTabsFit(menu_layout);

		window.addEventListener('resize', checkIfTabsFit);

		return () => {
			window.removeEventListener('resize', checkIfTabsFit);
		}
	}, [ menu_layout ]);

	if(force_display === false && force_type === false && !displayPromoHeader(promo)) {
		if(!is_test || is_builder) return null;
		
		return (
			<HeaderWrapper {...wrapper_props} />
		)
	}

	const menu_props = {
		promo,
		menus,
		manifest_enabled,
		actual_page:props.actual_page,
		is_builder,
		is_test,
		force_display,
		display_my_participation,
		login_data,
		login_id,
		share_info:props.share_info,
		hide_menu,
		loyalty_tokens,
		pending_tickets:props.pending_tickets,
		locale:props.locale,
		intl:props.intl,
	};

	if(menu_layout == 'empty') {
		return (
			<HeaderWrapper {...wrapper_props}>
				<MainMenuEmpty hide_menu={hide_menu} />
			</HeaderWrapper>
		)
	}

	if(menu_layout == 'simple') {
		return (
			<HeaderWrapper {...wrapper_props}>
				<MainMenuSimple {...menu_props} />
			</HeaderWrapper>
		)
	}

	if(menu_layout == 'tab' && fits_as_tabs) {
		return (
			<HeaderWrapper {...wrapper_props}>
				<MainMenuTabs {...menu_props} />
			</HeaderWrapper>
		)
	}

	return (
		<HeaderWrapper {...wrapper_props}>
			<MainMenuClassic {...menu_props} />
		</HeaderWrapper>
	)
});

export default injectIntl(MainMenuFlex, { withRef:true });